/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_EmptyInputs */

const cs_videos_empty = /** @type {(inputs: Videos_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádná videa.`)
};

const en_videos_empty = /** @type {(inputs: Videos_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No videos yet.`)
};

/**
* | output |
* | --- |
* | "No videos yet." |
*
* @param {Videos_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_empty = /** @type {((inputs?: Videos_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_empty(inputs)
	return cs_videos_empty(inputs)
});